export const shareItemOnPinterest = (url: string, entityName: string, mediaUrl: string): void => {
  window.open(
    `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${mediaUrl}&description=${encodeURIComponent(`${entityName}`)}`,
    'sharer',
    'toolbar=0,status=0,width=626,height=436'
  );
};

export const shareItemOnFacebook = (url: string, entityName: string): void => {
  window.PMW.fb
    .init()
    .then(() => {
      const {FB} = window as any;

      if (FB) {
        FB.ui({
          method: 'share',
          display: 'popup',
          href: url,
          caption: `${entityName}`,
        });
      } else {
        alert(window.i18next.t('pmwjs_unable_to_contact_fb_wait_reload'));
      }
    })
    .catch(() => {
      alert(window.i18next.t('pmwjs_unable_to_contact_fb_wait_reload'));
    });
};

export const shareItemOnX = (url: string, entityName: string): void => {
  window.open(
    `https://twitter.com/share?url=${encodeURIComponent(url)}&related=postermywall&text=${encodeURIComponent(`${entityName}`)}`,
    'sharer',
    'toolbar=0,status=0,width=626,height=436'
  );
};
